<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-img :src="frame" contain>
          <choose-module-component class="main-card-back"></choose-module-component>
          <v-row no-gutters class="first-line">
            <v-col cols="2"></v-col>
            <v-col cols="2">
              <span class="text-index card-title">آسایار</span>
            </v-col>
            <v-col cols="1"></v-col>
            <v-col cols="3">
              <span class="text-index card-subtitle mt-n5 mr-13">
                سامانه اتوماسیون اورژانس پیش بیمارستانی
              </span>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row no-gutters class="second-line">
            <v-spacer></v-spacer>
            <span class="text-index card-text-title">
              کاربر گرامی، جهت ورود به هر یک از سامانه های زیر بر روی “ ورود به سامانه” کلیک نمایید.
            </span>
            <v-spacer></v-spacer>
          </v-row>
          <v-row v-if="pageType == 'module'">
            <v-col cols="1"></v-col>
            <v-col cols="10" class="mt-5 main-part-module">
              <v-row>
                <v-col cols="3" v-if="admin">
                  <v-card elevation="0" class="items-card" height="20vh">
                    <v-card-text>
                      <v-card elevation="0" class="items-card-inside-2 mr-4 ml-n4" height="16vh">
                        <v-card elevation="3" class="items-card-inside-3 mr-4" height="16vh">
                          <v-card-text>
                            <v-row>
                              <v-icon color="#E7F3FF" class="">
                                mdi-shield-account-variant mdi-36px
                              </v-icon>
                              <v-spacer></v-spacer>
                              <span class="inside-card-title">ادمین آسایار</span>
                              <v-spacer></v-spacer>
                            </v-row>
                            <v-row>
                              <v-spacer></v-spacer>
                              <v-col cols="5" class="mt-2">
                                <v-btn block rounded class="normal-letter-spacing card-admin-btn-text"
                                  @click="goToProject('admin')">
                                  ورود به سامانه
                                </v-btn>
                              </v-col>
                              <v-spacer></v-spacer>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-card>
                      <v-icon class="mt-n10" color="white">
                        mdi-shield-account-variant mdi-36px
                      </v-icon>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="3" v-if="amar">
                  <v-card elevation="0" class="items-card-2" height="20vh">
                    <v-card-text>
                      <v-card elevation="0" class="items-card-inside-2-2 mr-4 ml-n4" height="16vh">
                        <v-card elevation="3" class="items-card-inside-3 mr-4" height="16vh">
                          <v-card-text>
                            <v-row>
                              <v-icon color="#E7F3FF" class="">mdi-finance mdi-36px</v-icon>
                              <v-spacer></v-spacer>
                              <span class="inside-card-title">آمار آسایار</span>
                              <v-spacer></v-spacer>
                            </v-row>
                            <v-row>
                              <v-spacer></v-spacer>
                              <v-col cols="5" class="mt-2">
                                <v-btn block rounded class="normal-letter-spacing card-admin-btn-text2"
                                  @click="goToProject('amar')">
                                  ورود به سامانه
                                </v-btn>
                              </v-col>
                              <v-spacer></v-spacer>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-card>
                      <v-icon class="mt-n10" color="white">mdi-finance mdi-36px</v-icon>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="3" v-if="doctor">
                  <v-card elevation="0" class="items-card-3" height="20vh">
                    <v-card-text>
                      <v-card elevation="0" class="items-card-inside-2-3 mr-4 ml-n4" height="16vh">
                        <v-card elevation="3" class="items-card-inside-3 mr-4" height="16vh">
                          <v-card-text>
                            <v-row>
                              <v-icon color="#E7F3FF" class="">mdi-stethoscope mdi-36px</v-icon>
                              <v-spacer></v-spacer>
                              <span class="inside-card-title">پزشک آسایار</span>
                              <v-spacer></v-spacer>
                            </v-row>
                            <v-row>
                              <v-spacer></v-spacer>
                              <v-col cols="5" class="mt-2">
                                <v-btn block rounded @click="goToProject('doctor')"
                                  class="normal-letter-spacing card-admin-btn-text3">
                                  ورود به سامانه
                                </v-btn>
                              </v-col>
                              <v-spacer></v-spacer>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-card>
                      <v-icon class="mt-n10" color="white">mdi-stethoscope mdi-36px</v-icon>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="3" v-if="nurse">
                  <v-card elevation="0" class="items-card-4" height="20vh">
                    <v-card-text>
                      <v-card elevation="0" class="items-card-inside-2-4 mr-4 ml-n4" height="16vh">
                        <v-card elevation="3" class="items-card-inside-3 mr-4" height="16vh">
                          <v-card-text>
                            <v-row>
                              <v-icon color="#E7F3FF" class="">mdi-medication mdi-36px</v-icon>
                              <v-spacer></v-spacer>
                              <span class="inside-card-title">115 آسایار</span>
                              <v-spacer></v-spacer>
                            </v-row>
                            <v-row>
                              <v-spacer></v-spacer>
                              <v-col cols="5" class="mt-2">
                                <v-btn block rounded @click="goToProject('115')"
                                  class="normal-letter-spacing card-admin-btn-text4">
                                  ورود به سامانه
                                </v-btn>
                              </v-col>
                              <v-spacer></v-spacer>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-card>
                      <v-icon class="mt-n10" color="white">mdi-medication mdi-36px</v-icon>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="3" v-if="qc">
                  <v-card elevation="0" class="items-card-5" height="20vh">
                    <v-card-text>
                      <v-card elevation="0" class="items-card-inside-2-5 mr-4 ml-n4" height="16vh">
                        <v-card elevation="3" class="items-card-inside-3 mr-4" height="16vh">
                          <v-card-text>
                            <v-row>
                              <v-icon color="#E7F3FF" class="">mdi-check-decagram mdi-36px</v-icon>
                              <v-spacer></v-spacer>
                              <span class="inside-card-title">کنترل کیفیت آسایار</span>
                              <v-spacer></v-spacer>
                            </v-row>
                            <v-row>
                              <v-spacer></v-spacer>
                              <v-col cols="5" class="mt-2">
                                <v-btn block rounded @click="goToProject('qc')"
                                  class="normal-letter-spacing card-admin-btn-text5">
                                  ورود به سامانه
                                </v-btn>
                              </v-col>
                              <v-spacer></v-spacer>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-card>
                      <v-icon class="mt-n10" color="white">mdi-check-decagram mdi-36px</v-icon>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="3" v-if="followUp">
                  <v-card elevation="0" class="items-card-6" height="20vh">
                    <v-card-text>
                      <v-card elevation="0" class="items-card-inside-2-6 mr-4 ml-n4" height="16vh">
                        <v-card elevation="3" class="items-card-inside-3 mr-4" height="16vh">
                          <v-card-text>
                            <v-row>
                              <v-icon color="#E7F3FF" class="">mdi-folder-open mdi-36px</v-icon>
                              <v-spacer></v-spacer>
                              <span class="inside-card-title">پیگیری آسایار</span>
                              <v-spacer></v-spacer>
                            </v-row>
                            <v-row>
                              <v-spacer></v-spacer>
                              <v-col cols="5" class="mt-2">
                                <v-btn block rounded @click="goToProject('followUp')"
                                  class="normal-letter-spacing card-admin-btn-text6">
                                  ورود به سامانه
                                </v-btn>
                              </v-col>
                              <v-spacer></v-spacer>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-card>
                      <v-icon class="mt-n10" color="white">mdi-folder-open mdi-36px</v-icon>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="3" v-if="dispather">
                  <v-card elevation="0" class="items-card-7" height="20vh">
                    <v-card-text>
                      <v-card elevation="0" class="items-card-inside-2-7 mr-4 ml-n4" height="16vh">
                        <v-card elevation="3" class="items-card-inside-3 mr-4" height="16vh">
                          <v-card-text>
                            <v-row>
                              <v-icon color="#E7F3FF" class="">mdi-medical-bag mdi-36px</v-icon>
                              <v-spacer></v-spacer>
                              <span class="inside-card-title">800 آسایار</span>
                              <v-spacer></v-spacer>
                            </v-row>
                            <v-row>
                              <v-spacer></v-spacer>
                              <v-col cols="5" class="mt-2">
                                <v-btn block rounded @click="goToProject('800')"
                                  class="normal-letter-spacing card-admin-btn-text7">
                                  ورود به سامانه
                                </v-btn>
                              </v-col>
                              <v-spacer></v-spacer>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-card>
                      <v-icon class="mt-n10" color="white">mdi-medical-bag mdi-36px</v-icon>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="3" v-if="admission">
                  <v-card elevation="0" class="items-card-8" height="20vh">
                    <v-card-text>
                      <v-card elevation="0" class="items-card-inside-2-8 mr-4 ml-n4" height="16vh">
                        <v-card elevation="3" class="items-card-inside-3 mr-4" height="16vh">
                          <v-card-text>
                            <v-row>
                              <v-icon color="#E7F3FF" class="">
                                mdi-hospital-building mdi-36px
                              </v-icon>
                              <v-spacer></v-spacer>
                              <span class="inside-card-title">پذیرش آسایار</span>
                              <v-spacer></v-spacer>
                            </v-row>
                            <v-row>
                              <v-spacer></v-spacer>
                              <v-col cols="5" class="mt-2">
                                <v-btn block rounded @click="goToProject('admission')"
                                  class="normal-letter-spacing card-admin-btn-text8">
                                  ورود به سامانه
                                </v-btn>
                              </v-col>
                              <v-spacer></v-spacer>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-card>
                      <v-icon class="mt-n10" color="white">mdi-hospital-building mdi-36px</v-icon>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="3" v-if="hospital">
                  <v-card elevation="0" class="items-card-8" height="20vh">
                    <v-card-text>
                      <v-card elevation="0" class="items-card-inside-2-8 mr-4 ml-n4" height="16vh">
                        <v-card elevation="3" class="items-card-inside-3 mr-4" height="16vh">
                          <v-card-text>
                            <v-row>
                              <v-icon color="#E7F3FF" class="">
                                mdi-hospital-building mdi-36px
                              </v-icon>
                              <v-spacer></v-spacer>
                              <span class="inside-card-title">بیمارستان آسایار</span>
                              <v-spacer></v-spacer>
                            </v-row>
                            <v-row>
                              <v-spacer></v-spacer>
                              <v-col cols="5" class="mt-2">
                                <v-btn block rounded @click="goToProject('hospital')"
                                  class="normal-letter-spacing card-admin-btn-text8">
                                  ورود به سامانه
                                </v-btn>
                              </v-col>
                              <v-spacer></v-spacer>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-card>
                      <v-icon class="mt-n10" color="white">mdi-hospital-building mdi-36px</v-icon>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="3" v-if="otherOrganization">
                  <v-card elevation="0" class="items-card-8" height="20vh">
                    <v-card-text>
                      <v-card elevation="0" class="items-card-inside-2-8 mr-4 ml-n4" height="16vh">
                        <v-card elevation="3" class="items-card-inside-3 mr-4" height="16vh">
                          <v-card-text>
                            <v-row>
                              <v-icon color="#E7F3FF" class="">mdi-office-building mdi-36px</v-icon>
                              <v-spacer></v-spacer>
                              <span class="inside-card-title">سازمان همکار آسایار</span>
                              <v-spacer></v-spacer>
                            </v-row>
                            <v-row>
                              <v-spacer></v-spacer>
                              <v-col cols="5" class="mt-2">
                                <v-btn block rounded @click="goToProject('otherOrgan')"
                                  class="normal-letter-spacing card-admin-btn-text8">
                                  ورود به سامانه
                                </v-btn>
                              </v-col>
                              <v-spacer></v-spacer>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-card>
                      <v-icon class="mt-n10" color="white">mdi-office-building mdi-36px</v-icon>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="3" v-if="dispatherEoc">
                  <v-card elevation="0" class="items-card-7" height="20vh">
                    <v-card-text>
                      <v-card elevation="0" class="items-card-inside-2-7 mr-4 ml-n4" height="16vh">
                        <v-card elevation="3" class="items-card-inside-3 mr-4" height="16vh">
                          <v-card-text>
                            <v-row>
                              <v-icon color="#E7F3FF" class="">mdi-medical-bag mdi-36px</v-icon>
                              <v-spacer></v-spacer>
                              <span class="inside-card-title">کارشناس EOC آسایار</span>
                              <v-spacer></v-spacer>
                            </v-row>
                            <v-row>
                              <v-spacer></v-spacer>
                              <v-col cols="5" class="mt-2">
                                <v-btn block rounded @click="goToProject('eoc')"
                                  class="normal-letter-spacing card-admin-btn-text7">
                                  ورود به سامانه
                                </v-btn>
                              </v-col>
                              <v-spacer></v-spacer>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-card>
                      <v-icon class="mt-n10" color="white">mdi-medical-bag mdi-36px</v-icon>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="3" v-if="dashboards">
                  <v-card elevation="0" class="items-card-5" height="20vh">
                    <v-card-text>
                      <v-card elevation="0" class="items-card-inside-2-5 mr-4 ml-n4" height="16vh">
                        <v-card elevation="3" class="items-card-inside-3 mr-4" height="16vh">
                          <v-card-text>
                            <v-row>
                              <v-icon color="#E7F3FF" class="">mdi-check-decagram mdi-36px</v-icon>
                              <v-spacer></v-spacer>
                              <span class="inside-card-title">داشبوردهای آسایار</span>
                              <v-spacer></v-spacer>
                            </v-row>
                            <v-row>
                              <v-spacer></v-spacer>
                              <v-col cols="5" class="mt-2">
                                <v-btn block rounded @click="goToProject('dashboards')"
                                  class="normal-letter-spacing card-admin-btn-text5">
                                  ورود به سامانه
                                </v-btn>
                              </v-col>
                              <v-spacer></v-spacer>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-card>
                      <v-icon class="mt-n10" color="white">mdi-check-decagram mdi-36px</v-icon>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
          <v-row v-if="pageType == 'extension'">
            <v-col cols="1"></v-col>
            <v-col cols="3" class="select-extension">
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="11" class="mr-4 data-part">
                  <v-row>
                    <v-col cols="6" v-for="item in allExtensionsForOther" :key="item.id">
                      <v-btn block large color="#943A2D" dark elevation="0" rounded @click="confirmedExtension(item)">
                        {{ item.sipExtension }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="8">
              <v-img :src="modulePic" contain max-height="48vh" class="mr-16"></v-img>
            </v-col>
          </v-row>
          <v-row v-if="pageType == 'zone'">
            <v-col cols="1"></v-col>
            <v-col cols="3" class="select-extension">
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="11" class="mr-4 data-part">
                  <v-row>
                    <v-col cols="6" v-for="item in allZones" :key="item.id">
                      <v-btn block large color="#943A2D" dark elevation="0" rounded @click="confirmedZone(item)">
                        {{ item.title }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="8">
              <v-img :src="modulePic" contain max-height="48vh" class="mr-16"></v-img>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import CryptoJS from 'crypto-js';

import AlertComponent from '../components/AlertComponent.vue';
import ChooseModuleComponent from '@/components/ChooseModuleComponent.vue';

import snackBar from '@/Mixins/snackBar.js';
import shearedMixin from '@/Mixins/Shared.js';
import ExtensionMixin from '@/Mixins/BaseInformation/ExtensionMixin';
import ZoneMixin from '@/Mixins/BaseInformation/ZoneMixin';
import ChooseModuleHelper from '@/Helpers/ChooseModuleHelper.js';
import UserMixin from '@/Mixins/BaseInformation/UserMixin.js';

export default {
  components: {
    ChooseModuleComponent,
    AlertComponent,
  },
  mixins: [shearedMixin, ExtensionMixin, snackBar, ZoneMixin, ChooseModuleHelper, UserMixin],
  created() {
    this.$root.$refs.ChooseModule = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {
      frame: require('@/assets/images/back.png'),
      modulePic: require('@/assets/images/module.png'),
    };
  },
  methods: {
    mounte: function () {
      let route = this.$route.params.id;
      let bytes = CryptoJS.AES.decrypt(route, 'w87ut12BGF0214dAS');
      let moduleId = '';
      if (bytes.sigBytes != 0) {
        moduleId = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      } else {
        moduleId = '';
      }
      if (moduleId == 1) {
        this.pageType = 'module';
        let temp = this.$store.state.userModule.roleId;
        for (let i = 0; i < temp.length; i++) {
          if (temp[i] === 1) {
            this.admin = true;
          } else if (temp[i] === 2) {
            //800
            this.dispather = true;
          } else if (temp[i] === 3) {
            //115
            this.nurse = true;
          } else if (temp[i] === 6) {
            //admission
            this.admission = true;
          } else if (temp[i] === 7) {
            //followUp
            this.followUp = true;
          } else if (temp[i] === 8) {
            //doctor
            this.doctor = true;
          } else if (temp[i] === 9) {
            //hospital
            this.hospital = true;
          } else if (temp[i] === 10) {
            //qc
            this.qc = true;
          } else if (temp[i] === 11) {
            //qc
            this.amar = true;
          } else if (temp[i] === 12) {
            //other organization
            this.otherOrganization = true;
          }
          else if (temp[i] === 14) {
            //other organization
            this.dispatherEoc = true;
          }
          else if (temp[i] === 15) {
            this.dashboards = true;
          }
        }
      } else {
        this.$router.push({ name: 'login' });
      }
    },
  },
};
</script>
<style scoped>
.main-part-module {
  height: 47vh !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.main-card-back {
  position: absolute;
  width: 180vh !important;
  height: 100vh !important;
  right: 6%;
  z-index: 0 !important;
}

.first-line {
  margin-top: 16vh !important;
}

.second-line {
  margin-top: 12vh !important;
}

.card-title {
  position: absolute;
  font-size: 34px;
  font-weight: 400;
  color: var(--dark-color);
  font-family: 'Shekasteh2Beta';
}

.card-subtitle {
  position: absolute;
  font-size: 32px;
  font-weight: 400;
  color: var(--dark-color);
  font-family: 'Shekasteh2Beta';
}

.card-text-title {
  margin-right: 6vh;
  font-size: 16px;
  font-weight: 500;
  color: #212121;
  letter-spacing: normal !important;
}

.items-card {
  background: #04468b !important;
  border-radius: 12px !important;
}

.items-card-2 {
  background: #2edf93 !important;
  border-radius: 12px !important;
}

.items-card-3 {
  background: #4ea699 !important;
  border-radius: 12px !important;
}

.items-card-4 {
  background: #ab3428 !important;
  border-radius: 12px !important;
}

.items-card-5 {
  background: #ff942f !important;
  border-radius: 12px !important;
}

.items-card-6 {
  background: #767fb0 !important;
  border-radius: 12px !important;
}

.items-card-7 {
  background: #2e933c !important;
  border-radius: 12px !important;
}

.items-card-8 {
  background: #2f3765 !important;
  border-radius: 12px !important;
}

.items-card-inside-2 {
  background: #2a629f !important;
  border-bottom-right-radius: 250px !important;
}

.items-card-inside-2-2 {
  background: #4cdca6 !important;
  border-bottom-right-radius: 250px !important;
}

.items-card-inside-2-3 {
  background: #63ada9 !important;
  border-bottom-right-radius: 250px !important;
}

.items-card-inside-2-4 {
  background: #b05653 !important;
  border-bottom-right-radius: 250px !important;
}

.items-card-inside-2-5 {
  background: #f3a358 !important;
  border-bottom-right-radius: 250px !important;
}

.items-card-inside-2-6 {
  background: #8491bf !important;
  border-bottom-right-radius: 250px !important;
}

.items-card-inside-2-7 {
  background: #4a9f61 !important;
  border-bottom-right-radius: 250px !important;
}

.items-card-inside-2-8 {
  background: #48507e !important;
  border-bottom-right-radius: 250px !important;
}

.items-card-inside-3 {
  border-bottom-right-radius: 250px !important;
  margin-left: -16vh !important;
  border-top-left-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.inside-card-title {
  font-weight: 500;
  font-size: 18px;
  color: #212121;
  margin-top: 8px;
}

.card-admin-btn-text {
  color: #04468b !important;
}

.card-admin-btn-text2 {
  color: #2edf93 !important;
}

.card-admin-btn-text3 {
  color: #4ea699 !important;
}

.card-admin-btn-text4 {
  color: #ab3428 !important;
}

.card-admin-btn-text5 {
  color: #ff942f !important;
}

.card-admin-btn-text6 {
  color: #767fb0 !important;
}

.card-admin-btn-text7 {
  color: #2e933c !important;
}

.card-admin-btn-text8 {
  color: #2f3765 !important;
}

.data-part {
  height: 45vh;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
